import React from 'react';
import PropTypes from 'prop-types';

export const getCarSyncStatusIcon = (status) => {
  let statusToLower =  status.toLowerCase();
  if (statusToLower === "not_installed") {
    return ( 
    <span className="fa-stack car__status-icon">
      <i className="fa fa-arrow-circle-up fa-stack-1x" style={{color: '#003d8c'}}></i>
    </span>
    );
  } else if (statusToLower === "missing") {
    return ( 
      <span className="fa-stack car__status-icon">
        <i className="fa fa-times-circle status-icon-alert fa-stack-1x" style={{color: 'red'}}></i>
      </span>
    );
  }
}

export const getCarSoftwareStatusIcon = (status) => {
  let statusToLower =  status.toLowerCase();
  if (statusToLower === "sanctioned") {
    return (
      <span className="fa-stack">
        <i className="fa fa-circle fa-stack-1x" style={{fontSize: 20, color: 'green'}}></i>
        <i className="fa fa-check-double fa-stack-1x fa-xs" style={{color: 'white'}}></i>
      </span>
    );
  } else if (statusToLower === "engineering") {
    return (
      <span className="fa-stack">
        <i className="fa fa-circle fa-stack-1x" style={{fontSize: 20, color: 'black'}}></i>
        <i className="fa fa-wrench fa-stack-1x fa-xs" style={{color: 'white'}}></i>
      </span>
    );
  } else if (statusToLower === "valid") {
    return (
      <span className="fa-stack">
        <i className="fa fa-circle fa-stack-1x" style={{fontSize: 20, color: 'orange'}}></i>
        <i className="fa fa-check fa-stack-1x fa-xs" style={{color: 'white'}}></i>
      </span>
    );
  } else if (statusToLower === "unknown") {
    return (
      <span className="fa-stack">
      <i className="fa fa-circle fa-stack-1x" style={{fontSize: 20, color: 'gray'}}></i>
      <i className="fa fa-question fa-stack-1x fa-xs" style={{color: 'white'}}></i>
    </span>
    );
  }
}

const goToTrainManagementPage = (state, carNumber, consist) => {
  state.go('train.management', { carNumber: carNumber, consist: consist });
}

export const RenderTrain = (row, state, hasHighSpeedTrain, trainHasWideCar) => {
  return (
    <div key={row.original.id} className="train">
      {row.original.carFiles.map(item => (
        <div key={item.carNumber} className={"car " + (hasHighSpeedTrain ? "high-speed-car " : "") + (trainHasWideCar ? "wide-car" : "")}>
          <div className={"car__rect " + (hasHighSpeedTrain ? "high-speed-rect " : "") + (trainHasWideCar ? "wide-car-rect" : "")}>
          <div className="car__col">
            {getCarSoftwareStatusIcon(item.carSoftwareStatus)}
          </div>
          <div className="car__col">
            <span className="car__car-title" onClick={() => goToTrainManagementPage(state, item.carNumber, row.original.trainId)}>{item.carNumber}</span>
          </div>
          <div className="car__col">
            {getCarSyncStatusIcon(item.carSyncStatus)}
          </div>
        </div>
        <div className="car__connector"></div>
        <div>
          <div className="car__wheel-one"></div>
          <div className="car__wheel-two"></div>
          <div className={"car__wheel-four " + (trainHasWideCar ? "wide-car" : "")}></div>
          <div className={"car__wheel-four " + (trainHasWideCar ? "wide-car" : "")}></div>
        </div>
      </div>
      ))}
    </div>
  );
}

RenderTrain.propTypes = {
  state: PropTypes.object, // ref to AngularJS state service
  row: PropTypes.object //table row containing a object in an array returned by GET software-status endpoint
}

export default RenderTrain;